import i18n from '@/i18n/i18n'
import { notifyWarning } from '@/layouts/notifies'
/**
 * Touch Module
 */
export default socket => {
  socket.on('notification', function({ message }) {
    notifyWarning(message, i18n.t('notices.notice'))
  })
}
